import React, { Component } from 'react';
import axios from 'axios';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import './SavedTrades.css';
import { ScenarioHeader } from '../Components/ScenarioHeader';
import { CustomNav } from '../Components/CustomNav';
import { ResponseSpinner } from '../Components/ResponseSpinner';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { FadeLoader } from 'react-spinners';
import Toggle from 'react-toggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlusSquare,
  faTimes,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import 'react-toggle/style.css'; // for ES6 modules
import { RadioGroup, Radio } from 'react-radio-group';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { userActions, scenarioActions } from '../_actions';
import latinize from 'latinize';
import './contract.css';

class SavedTrades extends Component {
  constructor(props) {
    super(props);
    this.state = {
      free_agents: [],
      buyouts: [],
      saved_trades: [],
      active_trade: [],
      savedScenarios: ['1', '2', '3'],
      selectedTrades: [],
      selectedScenario: '',
      requestState: '',
      scenarioName: '',
      breakdownIndex: null,
      scenarioBuyouts: [],
      scenarioBuyoutSeason: 2019,
      scenarioSigningSeason: 2019,
      scenarioSigningLength: 1,
      scenarioSigningAAV: 0,
      scenarioFirstYearBaseSalary: null,
      scenarioFirstYearSigningBonus: null,
      scenarioContractType: 'one-way',
      scenarioFreeAgents: [],
      startDate: moment(),
      signingDates: [],
      tradeDates: []
    };
    this.applyScenario = this.applyScenario.bind(this);
    this.saveScenario = this.saveScenario.bind(this);
    this.modifyTrade = this.modifyTrade.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleScenarioClick = this.handleScenarioClick.bind(this);
  }
  componentWillMount() {
    let currentComponent = this;
    axios
      .all([
        axios.get(apiServerUrl + '/free_agents', requestOptions()),
        axios.get(apiServerUrl + '/buyouts', requestOptions()),
        axios.get(apiServerUrl + '/saved_trades', requestOptions())
      ])
      .then(
        axios.spread((free_agents, buyouts, saved_trades) => {
          console.log('spreading');
          console.log(saved_trades);

          currentComponent.setState({
            free_agents: free_agents.data ? free_agents.data : [],
            buyouts: buyouts.data ? buyouts.data : [],
            saved_trades: saved_trades.data ? saved_trades.data : []
          });

          {
            /*if (saved_trades.data) {
            currentComponent.setState({
              saved_trades: saved_trades.data
            });
          }
          if (free_agents.data && buyouts.data && saved_trades.data) {
            currentComponent.setState({
              free_agents: free_agents.data,
              buyouts: buyouts.data,
              saved_trades: saved_trades.data
            });
          } else if (free_agents.data && saved_trades.data) {
            currentComponent.setState({
              free_agents: free_agents.data,
              saved_trades: saved_trades.data
            });
          }*/
          }
        })
      )
      .catch(function(error) {
        console.log(error);
      });

    this.updateScenarios();
  }

  updateScenarios() {
    let currentComponent = this;
    axios
      .get(apiServerUrl + '/saved_scenarios', requestOptions())
      .then(function(response) {
        currentComponent.setState({
          savedScenarios: response.data
        });
      })
      .catch(function(error) {
        //console.log(error);
      });
  }
  handleClick(e, trade, index) {
    //e.preventDefault();
    console.log(e, trade, index);
    console.log('The link was clicked.');
    //array.splice(index, 1);
    let newReport = {};
    axios
      .post(
        apiServerUrl + '/delete_trade?trade_id=' + trade.trade_id,
        newReport,
        requestOptions()
      )
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
    let currentComponent = this;
    let old = this.state.saved_trades;
    old.splice(index, 1);
    currentComponent.setState({
      saved_trades: old
    });
  }
  handleScenarioClick(e, scenario, index) {
    //e.preventDefault();
    console.log(e, scenario, index);
    console.log(scenario.scenario_id);
    //array.splice(index, 1);
    let newReport = {};
    axios
      .post(
        apiServerUrl + '/delete_scenario?scenario_id=' + scenario.scenario_id,
        newReport,
        requestOptions()
      )
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });

    let currentComponent = this;
    let old = this.state.savedScenarios;
    old.splice(index, 1);
    currentComponent.setState({
      savedScenarios: old
    });
  }
  handleInputChange(event) {
    this.setState({ scenarioName: event.target.value });
  }
  modifyTrade(trade, index) {
    let currentComponent = this;
    console.log(
      trade,
      index,
      this.state.tradeDates[index],
      this.state.selectedTrades,
      this.state.selectedTrades.splice(index)
    );
    if (
      this.state.selectedTrades.length > 1 &&
      this.state.selectedTrades.find(x => x.trade_id === trade.trade_id)
    ) {
      delete this.state.selectedTrades[
        this.state.selectedTrades.indexOf(
          this.state.selectedTrades.find(x => x.trade_id === trade.trade_id)
        )
      ];
    } else {
      let scenarioTrade = {
        trade_id: trade.trade_id,
        effective_date: this.state.tradeDates[index]
          ? this.state.tradeDates[index].format('MM/DD/YYYY')
          : moment().format('MM/DD/YYYY')
      };
      currentComponent.setState({
        selectedTrades: this.state.selectedTrades.concat(scenarioTrade)
      });
    }
  }
  handleDateChange(date, type, index) {
    console.log(date, type, index);
    if (type === 'signing') {
      let dates = this.state.signingDates;
      dates[index] = date;
      this.setState({
        signingDates: dates
      });
    } else if (type === 'trade') {
      let dates = this.state.tradeDates;
      dates[index] = date;
      this.setState({
        tradeDates: dates
      });
    }
  }

  saveScenario() {
    let test = this.state.selectedTrades.filter(function(e) {
      return e;
    });
    let newScenario = {
      scenario: {
        trades: this.state.selectedTrades,
        buyouts: this.state.scenarioBuyouts,
        signings: this.state.scenarioFreeAgents,
        scenario_desc: this.state.scenarioName
      }
    };
    console.log(newScenario);
    if (
      !(
        newScenario.scenario.trades.length >= 1 ||
        newScenario.scenario.buyouts.length >= 1 ||
        newScenario.scenario.signings.length >= 1
      )
    ) {
      alert('Scenario cannot have 0 trades, buyouts, or siginings.');
    }
    let currentComponent = this;
    currentComponent.setState({
      requestState: 'loading'
    });
    axios
      .post(apiServerUrl + '/save_scenario', newScenario, requestOptions())
      .then(function(response) {
        currentComponent.updateScenarios();

        console.log(response);
        setTimeout(function() {
          currentComponent.setState({
            requestState: 'success'
          });
        }, 1500);
        setTimeout(function() {
          currentComponent.setState({
            requestState: ''
          });
        }, 3000);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  applyScenario(value) {
    console.log(value);
    let currentComponent = this;
    if (value != 'none') {
      this.props.dispatch(scenarioActions.applyScenario(value));
      currentComponent.setState({
        selectedScenario: value
      });
      alert(
        'You have new players to be moved into your roster in Team Management!'
      );
      this.props.dispatch(push('/team'));
    } else {
      this.props.dispatch(scenarioActions.removeScenario(value));
      currentComponent.setState({
        selectedScenario: ''
      });
    }
  }

  handleChange(e, id) {
    this.refs.freeAgentTable.filterColumn(
      this.freeAgentColumns[id],
      e.target.value
    );
  }

  signPlayer(player_id, index) {
    console.log(
      player_id,
      this.state.scenarioSigningSeason,
      this.state.scenarioSigningLength,
      this.state.scenarioContractType,
      this.state.scenarioSigningAAV,
      this.state.scenarioFirstYearBaseSalary,
      this.state.scenarioFirstYearSigningBonus,
      index
    );
    this.setState({
      scenarioFreeAgents: this.state.scenarioFreeAgents.concat({
        player_id: player_id,
        signing_year: +this.state.scenarioSigningSeason,
        contract_length: +this.state.scenarioSigningLength,
        contract_type: this.state.scenarioContractType,
        aav: +this.state.scenarioSigningAAV,
        first_year_base_salary: this.state.scenarioFirstYearBaseSalary
          ? +this.state.scenarioFirstYearBaseSalary
          : null,
        first_year_signing_bonus: this.state.scenarioFirstYearSigningBonus
          ? +this.state.scenarioFirstYearSigningBonus
          : null,
        effective_date: moment(this.state.signingDates[index]).format(
          'MM/DD/YYYY'
        )
      }),
      // reset state values after signing player
      scenarioSigningSeason: 2019,
      scenarioSigningLength: 1,
      scenarioSigningAAV: 0,
      scenarioFirstYearBaseSalary: null,
      scenarioFirstYearSigningBonus: null,
      scenarioContractType: 'one-way'
    });
  }

  buyoutPlayer(player_id) {
    console.log(player_id, this.state.scenarioBuyoutSeason);
    this.setState({
      scenarioBuyouts: this.state.scenarioBuyouts.concat({
        player_id: player_id,
        buyout_year: +this.state.scenarioBuyoutSeason.substring(0, 4)
      })
    });
  }

  freeAgentColumns = [
    {
      Header: 'Name',
      id: 'name',
      accessor: d => d.player_name,
      minWidth: 180,
      defaultSortDesc: false,
      filterMethod: (filter, row) => {
        return row[filter.id]
          ? latinize(row[filter.id])
              .toLowerCase()
              .includes(filter.value)
          : null;
      }
    },
    {
      Header: 'Team',
      id: 'team',
      accessor: d => d.current_team,
      minWidth: 100
    },
    {
      Header: 'Expiry Status',
      id: 'status',
      accessor: d => d.expiry_status,
      minWidth: 100
    },
    {
      Header: 'Season',
      id: 'season',
      accessor: d => d.season,
      minWidth: 100
    },
    {
      Header: 'Last Contract Details',
      id: 'last_contract_details',
      accessor: d => d.last_contract_details,
      defaultSortDesc: true,
      minWidth: 150
    },
    {
      Header: 'Sign Player',
      id: 'sign_player',
      minWidth: 250,
      accessor: d => d.signing_year,
      Cell: row => (
        <div>
          <div>
            <select
              onChange={e =>
                this.setState({ scenarioSigningSeason: e.target.value })
              }
            >
              <option value="">Season</option>
              <option name="signing_year" value={row.value}>
                {row.value}
              </option>
              <option name="signing_year" value={row.value + 1}>
                {row.value + 1}
              </option>
              <option name="signing_year" value={row.value + 2}>
                {row.value + 2}
              </option>
              <option name="signing_year" value={row.value + 3}>
                {row.value + 3}
              </option>
              <option name="signing_year" value={row.value + 4}>
                {row.value + 4}
              </option>
            </select>
            <select
              onChange={e =>
                this.setState({ scenarioSigningLength: e.target.value })
              }
            >
              <option name="contract_length" value={1}>
                1 Year
              </option>
              <option name="contract_length" value={2}>
                2 Years
              </option>
              <option name="contract_length" value={3}>
                3 Years
              </option>
              <option name="contract_length" value={4}>
                4 Years
              </option>
              <option name="contract_length" value={5}>
                5 Years
              </option>
              <option name="contract_length" value={6}>
                6 Years
              </option>
              <option name="contract_length" value={7}>
                7 Years
              </option>
              <option name="contract_length" value={8}>
                8 Years
              </option>
              <option name="contract_length" value={9}>
                9 Years
              </option>
              <option name="contract_length" value={10}>
                10 Years
              </option>
            </select>
            <select
              onChange={e =>
                this.setState({ scenarioContractType: e.target.value })
              }
            >
              <option value="">Contract</option>
              <option name="contract_type" value="one-way">
                One-Way
              </option>
              <option name="contract_type" value="two-way">
                Two-Way
              </option>
            </select>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                maxHeight: '2em',
                margin: 0,
                padding: 0
              }}
            >
              <strong>AAV:</strong>
              <input
                onChange={e =>
                  this.setState({ scenarioSigningAAV: e.target.value })
                }
                type="number"
                name="aav"
                style={{ maxWidth: '100%' }}
                placeholder="AAV"
              />
            </div>
            {row.value === 2018 &&
              this.state.free_agents[row.index].expiry_status === 'RFA' && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    maxHeight: '2em',
                    margin: 0,
                    padding: 0
                  }}
                >
                  <strong>Year 1: </strong>
                  <input
                    onChange={e =>
                      this.setState({
                        scenarioFirstYearBaseSalary: e.target.value
                      })
                    }
                    type="number"
                    name="first_year_base_salary"
                    style={{ maxWidth: '37%', flex: 1 }}
                    placeholder="Base Salary"
                  />
                  <input
                    onChange={e =>
                      this.setState({
                        scenarioFirstYearSigningBonus: e.target.value
                      })
                    }
                    type="number"
                    name="first_year_signing_bonus"
                    style={{ maxWidth: '45%', flex: 1 }}
                    placeholder="Signing Bonus"
                  />
                </div>
              )}
          </div>
          <div>
            {row.value == '2018' && (
              <div>
                Signing Date:
                <DatePicker
                  selected={
                    this.state.signingDates[row.index]
                      ? this.state.signingDates[row.index]
                      : this.state.startDate
                  }
                  onChange={e => {
                    this.handleDateChange(e, 'signing', row.index);
                  }}
                />
              </div>
            )}
            <input
              type="submit"
              value="Sign Player"
              onClick={e => {
                this.signPlayer(
                  this.state.free_agents[row.index].player_id,
                  row.index
                );
              }}
            />
            {this.state.scenarioFreeAgents.find(
              x => x.player_id === this.state.free_agents[row.index].player_id
            ) && (
              <span style={{ marginLeft: '0.5em' }}>Signing successful</span>
            )}
          </div>
        </div>
      )
    }
  ];
  buyoutColumns = [
    {
      Header: 'Name',
      id: 'name',
      accessor: d => d.player_name,
      minWidth: 180
    },
    {
      Header: 'Contract Type',
      id: 'contract_type',
      accessor: d => (d.contract_type ? d.contract_type.split(' ')[0] : null),
      minWidth: 140
    },
    {
      Header: 'Years Remaining',
      id: 'buyout_year_remaining',
      accessor: d => d.buyout_years_remaining,
      minWidth: 100,
      defaultSortDesc: true
    },
    {
      Header: 'Buyout Player',
      id: 'buyout_player',
      minWidth: 160,
      accessor: d => d.available_years,
      Cell: row => (
        <div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around'
            }}
          >
            <select
              onChange={e =>
                this.setState({ scenarioBuyoutSeason: e.target.value })
              }
            >
              <option value="">Season</option>
              {row.value.map(season => (
                <option value={season}>{season}</option>
              ))}
            </select>
            <input
              type="submit"
              value="Buyout Player"
              onClick={e => {
                this.buyoutPlayer(this.state.buyouts[row.index].player_id);
              }}
            />
          </div>
          <div>
            {this.state.scenarioBuyouts.find(
              x => x.player_id === this.state.buyouts[row.index].player_id
            ) && <span style={{ marginLeft: '0.5em' }}>Buyout successful</span>}
          </div>
        </div>
      )
    }
  ];
  breakdownColumns = [
    {
      Header: 'Season',
      id: 'season',
      accessor: d => d.season,
      minWidth: 100
    },
    {
      Header: 'Actual Cost',
      id: 'actual_cost',
      accessor: d =>
        d.actual_cost ? '$' + Math.round(d.actual_cost).toLocaleString() : null,
      minWidth: 100
    },
    {
      Header: 'Cap Hit',
      id: 'cap_hit',
      accessor: d =>
        d.cap_hit ? '$' + Math.round(d.cap_hit).toLocaleString() : null,
      minWidth: 100
    },
    {
      Header: 'Base Salary',
      id: 'base_salary',
      accessor: d =>
        d.base_salary ? '$' + Math.round(d.base_salary).toLocaleString() : null,
      minWidth: 100
    },
    {
      Header: 'Cash Savings',
      id: 'cash_savings',
      accessor: d =>
        d.cash_savings
          ? '$' + Math.round(d.cash_savings).toLocaleString()
          : null,
      minWidth: 100
    },
    {
      Header: 'Final Cap Hit',
      id: 'final_cap_hit',
      accessor: d =>
        d.final_cap_hit
          ? '$' + Math.round(d.final_cap_hit).toLocaleString()
          : null,
      minWidth: 100
    },
    {
      Header: 'Signing Bonus',
      id: 'sign_bonus',
      accessor: d =>
        d.sign_bonus ? '$' + Math.round(d.sign_bonus).toLocaleString() : null,
      minWidth: 100
    },
    {
      Header: 'Total Paid',
      id: 'total_cash_paid',
      accessor: d =>
        d.total_cash_paid
          ? '$' + Math.round(d.total_cash_paid).toLocaleString()
          : null,
      minWidth: 100
    }
  ];

  render() {
    return (
      <div>
        <header className="nav">
          <CustomNav />
          <ScenarioHeader />
        </header>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            className="left-side"
            style={{ display: 'flex', flexDirection: 'row' }}
          >
            <div
              style={{
                display: 'flex',
                flex: 5,
                flexDirection: 'column',
                margin: '1em'
              }}
            >
              <h2 style={{ color: 'white' }}>Sign Players</h2>
              <div style={{ background: '#133b56' }}>
                <input
                  onChange={e => this.handleChange(e, 0)}
                  placeholder={'Search Players'}
                />
              </div>
              <ReactTable
                data={this.state.free_agents}
                columns={this.freeAgentColumns}
                defaultSorted={[{ id: 'name', desc: false }]}
                defaultPageSize={10}
                ref="freeAgentTable"
                resizable={false}
                noDataText={
                  <FadeLoader color={'#123abc'} loading={this.state.loading} />
                }
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 2,
                margin: '1em'
              }}
            >
              <h2 style={{ color: 'white' }}>SAVED TRADES</h2>
              <div
                style={{
                  border: '1px solid grey',
                  overflow: 'scroll',
                  maxHeight: '860px'
                }}
              >
                <ol
                  id="savedTrades"
                  style={{
                    listStyleType: 'none',
                    textAlign: 'left',
                    padding: '0',
                    marginBottom: '0px'
                  }}
                >
                  <div className="tradeToggles">
                    {this.state.saved_trades &&
                      this.state.saved_trades.map((trade, index) => (
                        <li
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                          }}
                        >
                          <div>
                            {trade.team_one} - {trade.team_two} -{' '}
                            {trade.trade_desc}
                          </div>
                          <div style={{ display: 'flex' }}>
                            <div style={{ width: '6em', overflow: 'hidden' }}>
                              <DatePicker
                                selected={
                                  this.state.tradeDates[index]
                                    ? this.state.tradeDates[index]
                                    : this.state.startDate
                                }
                                onChange={e => {
                                  this.handleDateChange(e, 'trade', index);
                                }}
                              />
                            </div>
                            <label style={{ margin: '0.1em 0.5em' }}>
                              <Toggle
                                defaultChecked={false}
                                onChange={e => this.modifyTrade(trade, index)}
                              />
                            </label>
                            <FontAwesomeIcon
                              onClick={e => this.handleClick(e, trade, index)}
                              style={{
                                color: '#f783ac',
                                fontSize: '22px',
                                paddingLeft: '0px',
                                paddingTop: '0px'
                              }}
                              icon={faTimesCircle}
                            />
                          </div>
                        </li>
                      ))}
                  </div>
                </ol>
              </div>
              <div
                style={{
                  margin: '1em 1em 1em 1em',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                {/*}<Button>Apply Scenario</Button>*/}
                <input
                  type="text"
                  value={this.state.scenarioName}
                  onChange={this.handleInputChange}
                  placeholder="Scenario Name"
                  style={{ marginRight: '1em', width: '200px', height: '34px' }}
                />
                <Button onClick={this.saveScenario}>Save Scenario</Button>
                <ResponseSpinner loading={this.state.requestState} />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 5,
                margin: '0 1em '
              }}
            >
              <h2 style={{ color: 'white' }}>Buyout Players</h2>
              <ReactTable
                data={this.state.buyouts}
                columns={this.buyoutColumns}
                defaultPageSize={10}
                ref="buyoutTable"
                resizable={false}
                noDataText={
                  <FadeLoader color={'#123abc'} loading={this.state.loading} />
                }
                SubComponent={row => {
                  return (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        padding: '1em'
                      }}
                    >
                      {this.state.buyouts[row.index].buyout_seasons.map(
                        (buyout, index) => (
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column'
                            }}
                          >
                            <table>
                              <tbody>
                                <tr
                                  onClick={e => {
                                    if (this.state.breakdownIndex != index) {
                                      this.setState({ breakdownIndex: index });
                                    } else {
                                      this.setState({ breakdownIndex: null });
                                    }
                                  }}
                                >
                                  <th className="breakdownYear">
                                    {buyout.breakdown[0].buyout_year}
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                            {this.state.breakdownIndex === index && (
                              <ReactTable
                                data={buyout.breakdown}
                                columns={this.breakdownColumns}
                                showPagination={false}
                                defaultPageSize={buyout.breakdown.length}
                                ref="breakdownTable"
                              />
                            )}
                          </div>
                        )
                      )}
                    </div>
                  );
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 2,
                margin: '1em'
              }}
            >
              <h2 style={{ color: 'white' }}>APPLY SCENARIO</h2>
              <div style={{ overflow: 'scroll', maxHeight: '448px' }}>
                <RadioGroup
                  className="applyScenarios"
                  name="fruit"
                  selectedValue={this.state.selectedValue}
                  onChange={this.applyScenario}
                >
                  <div>
                    <label>None</label>
                    <Radio value="none" style={{ marginLeft: '0.5em' }} />
                  </div>
                  {this.state.savedScenarios &&
                    this.state.savedScenarios.map((scenario, index) => (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between'
                        }}
                      >
                        <label>
                          {' '}
                          Scenario: {scenario.description}
                          {scenario.scenario_date}{' '}
                        </label>
                        <span
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between'
                          }}
                        >
                          <Radio
                            value={scenario.scenario_id}
                            style={{ marginLeft: '0.5em', marginRight: '15px' }}
                          />
                          <FontAwesomeIcon
                            onClick={e =>
                              this.handleScenarioClick(e, scenario, index)
                            }
                            style={{
                              color: '#f783ac',
                              fontSize: '22px',
                              paddingLeft: '0px',
                              paddingTop: '0px'
                            }}
                            icon={faTimesCircle}
                          />
                        </span>
                      </div>
                    ))}
                </RadioGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    state
  };
}

const connectedSavedTrades = connect(mapStateToProps)(SavedTrades);
export { connectedSavedTrades as SavedTrades };



// WEBPACK FOOTER //
// ./src/Pages/SavedTrades.js